import { Dispatch } from "redux";
import api from "../../api/api";
import {
    setAssignmentsList,
    setloading,
    seterror,
    setPagination,
    resetAssignmentsList,
} from "../reducers/getAssignmentsByLessonReducer";

const getAssignmentsByLesson = (id: any, page: any, token: any, courseType: any, sortOption: string = "", searchQuery: string = "") => async (
    dispatch: Dispatch
) => {
    dispatch(setloading(true));
    try {
        const endpoint =
            courseType === 2
                ? `/competitive/assignments/get-assignments-by-lesson/${id}/`
                : `/assignments/get-assignments-by-lesson/${id}/`;

        const params: Record<string, any> = { page };
            if (sortOption) {
            params.sort = sortOption; // add sort param if provided
            }
            if (searchQuery) {
            params.search = searchQuery; // add search param if provided
            }
            // Add fetch_all parameter (default to false)
            params.fetch_all = false;

        const result = await api.get(endpoint , {
            params,
            headers: {
                "Content-Type": "multipart/form-data",
                Authorization: `Token ${token}`,
            },
        });

        if (result) {
            dispatch(setloading(false));
            if (result.data?.status === 200) {
                dispatch(setAssignmentsList(result.data.data));
                dispatch(setPagination(result.data));
            } else {
                dispatch(seterror(result.data?.message ?? "Something Went Wrong!"));
            }
        }
    } catch (error: any) {
        dispatch(setloading(false));
    }
};

export { getAssignmentsByLesson, resetAssignmentsList };
